exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-chip,\r\n.mat-chip:not(.mat-basic-chip) {\r\n\t background-color: #dbd4df;\r\n\t margin-bottom: 5px;\r\n }\r\n\r\n.success {\r\n  font-size: 18px;\r\n  color: #3eb049;\r\n}\r\n\r\n.error {\r\n  font-size: 18px;\r\n  color: red;\r\n}\r\n\r\n.warning {\r\n  font-size: 18px;\r\n  color: orangered;\r\n  text-wrap:normal\r\n}\r\n\r\n.name-edit-field {\r\n width: 22%;\r\n  min-width: 130px;\r\n}\r\n\r\n.email-edit-field {\r\n  width: 45%;\r\n  min-width: 300px;\r\n}\r\n\r\n.lo-relationship-indicator {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    top: -12px;\r\n}\r\n\r\n.lo-relationship-text {\r\n    font-size: 14px;\r\n    color: #3f51b5;\r\n}\r\n\r\n.lo-relationship-checkbox {\r\n    height: 16px;\r\n    width: 16px;\r\n    margin-left: 8px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-edit/user-edit.component.css
// module id = ../../../../../src/app/users/user-edit/user-edit.component.css
// module chunks = main